<template>
  <div class="home-card-wrap">
    <div class="home-card" :style="`flex-direction: ${direction};`">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    flex: Number,
    direction: {
      type: String,
      default: 'column'
    }
  }
}
</script>

<style lang="scss">
@keyframes leftTop {
  0%,
  100% {
    clip-path: polygon(0 0, 0 0, 0 0);
  }
  50% {
    clip-path: polygon(0 0, 0 100%, 100% 0);
  }
}
@keyframes rightBottom {
  0%,
  100% {
    clip-path: polygon(100% 100%, 100% 100%, 100% 100%);
  }
  50% {
    clip-path: polygon(2px 100%, 100% 100%, 100% 2px);
  }
}
.home-card-wrap {
  box-sizing: border-box;
}
.home-card-wrap:not(:last-child) {
  padding-bottom: 40px;
  height: calc(100% - 40px);
}
.home-card {
  color: rgb(154, 168, 212);
  box-shadow: inset 0 0 0 2px rgba(20, 53, 114, 0.9);
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;

  .subtitle {
    padding: 6px 4px;
  }
  .card-item {
    box-sizing: border-box;
  }
  // .card-item:not(:last-child) {
  //   // margin-bottom: 12px;
  // }
}
.home-card::before,
.home-card::after {
  content: '';
  position: absolute;
  display: block;
  width: calc(100% + 8px);
  height: calc(100% + 8px);
  margin: -4px;
  box-shadow: inset 0 0 0 2px rgba(0, 182, 252, 0.4);
  pointer-events: none;
}
.home-card::before {
  animation: leftTop 10s ease-in-out infinite;
}
.home-card::after {
  animation: rightBottom 10s ease-in-out infinite;
}
</style>
